import { createAntibioticSchema, createOrganismSchema } from '#shared/types';
import { RESOURCE } from '#client/lib/routes';

/**
 * The two microbiology catalogues. Both are a name and a code, managed the same
 * way, so one set of pages serves both and this is what differs.
 */
export interface NameCodeCatalogue {
  /** The permission prefix: `antibiotic.create`, `organism.edit` and so on. */
  permission: 'antibiotic' | 'organism';
  path: string;
  title: string;
  subtitle: string;
  noun: string;
  nounPlural: string;
  /** Capitalised, for toasts. */
  label: string;
  schema: typeof createAntibioticSchema;
  codeHelp: string;
}

export const ANTIBIOTICS: NameCodeCatalogue = {
  permission: 'antibiotic',
  path: RESOURCE.antibiotics,
  title: 'Antibiotics',
  subtitle: 'The antibiotics a culture’s sensitivity panel can test',
  noun: 'antibiotic',
  nounPlural: 'antibiotics',
  label: 'Antibiotic',
  schema: createAntibioticSchema,
  codeHelp: 'A short unique identifier, e.g. CRO for ceftriaxone',
};

export const ORGANISMS: NameCodeCatalogue = {
  permission: 'organism',
  path: RESOURCE.organisms,
  title: 'Organisms',
  subtitle: 'The organisms a culture can isolate, printed in italics on the report',
  noun: 'organism',
  nounPlural: 'organisms',
  label: 'Organism',
  schema: createOrganismSchema,
  codeHelp: 'A short unique identifier, e.g. ECOLI',
};
